
















































































































































































































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---
import { Return } from '@/models/Return.model';
import { OrderItem, Waybill } from '@/models/Waybill.model';

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';
import ReturnService from '@/services/return';
import WaybillService from '@/services/waybill';

// --- Third Party imports ---
import moment from 'moment';

@Component
export default class ReturnForm extends Vue {

  styleMe: boolean = true;

  clickedItem: Return = {
    id: 0,
    senderAddress: {
      contactPerson: '',
      phoneHome: '',
      phoneWork: '',
      phoneCell: '',
      email: '',
      companyName: '',
      address1: '',
      address2: '',
      address3: '',
      addressSuburb: '',
      addressProvince: '',
      addressCountry: '',
      postCode: '',
      boxCode: '',
    },
    collectionDate: '',
    collectionTime: '',
    specialInstructions: '',
  };
  collectionDatePicker: boolean = false;

  orderItems: OrderItem[] = [];
  itemsForReturn: OrderItem[] = [];
  totalReturnItems: number = 0;

  valid: boolean = false;
  itemSelected: boolean = false;
  rules = {
    required: (value: string) => value != null && !!value.toString().trim() || '',
    name: (value: string) => /^(?=.*[a-zA-Z- ])[a-zA-Z- ]+$/.test(value) || 'Remove invalid characters',
    phone: (value: string) => /^[0-9]{10}$/.test(value) || 'Please enter a valid Phone Number',
    email: (value: string) => /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'Please enter a valid E-mail Address',
    pluralAlphaNumeric: (value: string) => /^(?=.*[a-zA-Z0-9- \'])[a-zA-Z0-9- \']+$/.test(value) || 'Remove invalid characters',
    optionalPluralAlphaNumeric: (value: string) => (value != null && value.length > 0) ? /^(?=.*[a-zA-Z0-9- \'])[a-zA-Z0-9- \']+$/.test(value) || 'Remove invalid characters' : true,
    address: (value: string) => /^(?=.*[a-zA-Z0-9- ,.\'()&\/])[a-zA-Z0-9- ,.\'()&\/]+$/.test(value) || 'Remove invalid characters',
    optionalAddress: (value: string) => (value != null && value.length > 0) ? /^(?=.*[a-zA-Z0-9- ,.\'()&/])[a-zA-Z0-9- ,.\'()&/]+$/.test(value) || 'Remove invalid characters' : true,
    numbersOnly: (value: string) => (/^\d+$/.test(value)) || 'Invalid character',
    maxLength500: (value: string) => (value != null && value.length > 0) ? (value.length < 501) || 'Exceeds maximum length' : true,
    returnItemCounter: (value: number) => value > 0 || 'Please select at least 1 item for return',
  };

  headers() {
    return [  
      {
        text: 'SKU',
        value: 'sku',
      },        
      {
        text: 'Name',
        value: 'name',
      },        
      {
        text: 'Quantity',
        value: 'quantity',
      }, 
      {
        text: '',
        value: 'returnReason',
        width: (this.$vuetify.breakpoint.smAndDown ? '100%' : '25%'),
      },     
    ];
  }

  async beforeMount() {
    this.styleMe = this.$route.meta.styled;

    await WaybillService.getMyWaybill(false);
    await this.mapWaybillToReturn();

    if (this.$refs.itemForm) {
      (this.$refs.itemForm as any).validate();
    }
  }

  async mapWaybillToReturn() {
    const waybill: Waybill = this.$store.getters['thisWaybill/waybill'];
    this.clickedItem.senderAddress = Object.assign({}, waybill.toAddress);
    this.clickedItem.collectionDate = this.getMinDate();

    await this.listItemsByOrder();
  }

  async listItemsByOrder() {
    this.orderItems = [];
    const response = await WaybillService.listOrderItems();

    if (response && response.data) {
      if ((response.data.result && response.data.result === 'false') || response.data.length < 1) {
        AppService.errorHandler(response.data.message);
      } else {
        this.orderItems = response.data;

        this.orderItems = this.orderItems.reduce((a: any, b: any) => {
          let newItem = b;
          newItem = Object.assign({}, b, { returnQuantity: b.quantity });

          return a.concat(newItem);
        }, []);
      }
    }
  }

  checkItemSelected(items: OrderItem[]) {
    if (items.length > 0) {
      this.itemSelected = true;
    } else {
      this.itemSelected = false;
    }

    this.totalReturnItems = items.reduce((total: number, item: OrderItem) => {
      // https://stackoverflow.com/questions/14496531/adding-two-numbers-concatenates-them-instead-of-calculating-the-sum
      return +total + +item.returnQuantity;
    }, 0);

    this.$nextTick(() => {
      if (this.$refs.itemForm) {
        (this.$refs.itemForm as any).validate();
      }
    });
  }

  async resetItemSelected(selected: {item: OrderItem, value: boolean}) {
    selected.item.returnQuantity = selected.item.quantity; // reset the return Quantity when the item is either deselected or selected
    selected.item.returnReason = '';

    this.$nextTick(() => {
      if (this.$refs.itemForm) {
        (this.$refs.itemForm as any).validate();
      }
    });
  }

  updateTotalReturnItems() {
    this.totalReturnItems = this.itemsForReturn.reduce((total: number, item: OrderItem) => {
      // https://stackoverflow.com/questions/14496531/adding-two-numbers-concatenates-them-instead-of-calculating-the-sum
      return +total + +item.returnQuantity;
    }, 0);
  }

  getReturnQuantityItems(item: OrderItem) {
    const quantityArray: any = [];
    for (let i = 1; i <= item.quantity; i++) {
      quantityArray.push('' + i);
    }
    return quantityArray;
  }

  getMinDate() {
    // 2022-08-30 PJH: Updated to 5pm as requested by Sean
    // if it is after 5pm today, then you need to go day after tomorrow
    // otherwise tomorrow is fine
    let offset = 1;
    if (moment().isSameOrAfter(moment('17:00', 'HH:mm'))) {
      offset = 2;
    }

    return moment().add(offset, 'day').format('YYYY-MM-DD');
  }

  getAllowedDates(value: string) {
    // TODO at some point we should remove public holidays from this too!
    const valueMoment = moment(String(value));
    const returnVal = valueMoment.day() !== 0 && valueMoment.day() !== 6;
    return returnVal;
  }

  async doCreate() {
    try {
        const response = await ReturnService.create( { senderAddress: { 
          contactPerson: this.clickedItem.senderAddress.contactPerson, phoneCell: this.clickedItem.senderAddress.phoneCell, 
          email: this.clickedItem.senderAddress.email, companyName: this.clickedItem.senderAddress.companyName, 
          address1: this.clickedItem.senderAddress.address1, address2: this.clickedItem.senderAddress.address2, 
          address3: this.clickedItem.senderAddress.address3, addressSuburb: this.clickedItem.senderAddress.addressSuburb, 
          addressProvince: this.clickedItem.senderAddress.addressProvince, addressCountry: this.clickedItem.senderAddress.addressCountry, 
          postCode: this.clickedItem.senderAddress.postCode }, collectionDate: this.clickedItem.collectionDate, 
          totalItems: this.totalReturnItems, collectionTime: this.clickedItem.collectionTime, 
          specialInstructions: this.clickedItem.specialInstructions, 
          returnItems: this.itemsForReturn.map((item) => ({ id: item.id, sku: item.sku, name: item.name, quantity: item.quantity,
          returnQuantity: item.returnQuantity, returnReason: item.returnReason}) ) });

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            this.$router.push(this.styleMe ? '/waybill/complete' : '/waybill/iframe/complete');
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {

        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          await AuthService.logSupportDebug('ReturnForm.vue - doCreate - 406 - ' + error);
          AppService.errorHandler(this.$store.state.app.messages.couldNotConnect);
        }

      }
  }

}
